import type { FontOptions } from './types';

/**
 * Wrapper State
 */
export class State {
  optionFonts: FontOptions[]; // fonts for Font Selector in Sidebar
  activeFonts: FontOptions[]; // fonts for Active Fonts Panel on Font Manger Modal

  allGoogleFonts: FontOptions[]; // shown fonts for Google Fonts Tab on Font Manger Modal
  googleFontsScrollStep: number;

  themeFonts: FontOptions[];
  changeThemeFonts: boolean;

  // fonts in Installed Theme is being edited
  installedFonts: FontOptions[] | false;
  newInstalledFonts: FontOptions[];
  editingFonts: any[];
  uploadNumber: number;
  changeInstalledFonts: boolean;
  uploadStatus: string;
  fontFileTypes: string[];

  showFontManager: number;
  sampleText: string;
  containerRight: number;
  setupFontSelector: Map<string, any>;

  constructor() {
    this.optionFonts = [];
    this.activeFonts = [];

    this.allGoogleFonts = [];
    this.googleFontsScrollStep = 50;

    this.themeFonts = [];
    this.changeThemeFonts = false;

    this.installedFonts = false;
    this.newInstalledFonts = [];
    this.editingFonts = [];
    this.uploadNumber = 0;
    this.changeInstalledFonts = false;
    this.uploadStatus = '';
    this.fontFileTypes = ['ttf', 'eot', 'woff', 'woff2', 'otf'];

    this.showFontManager = -1;
    this.sampleText = 'abcdef123';
    this.containerRight = 0;
    this.setupFontSelector = new Map<string, any>();
  }
}

const state = new State();

export default state;
